import React, { FC } from 'react';
import { IonGrid, IonRow, IonCol } from '@ionic/react';

interface EmptyStateProps {
  message: string;
}

const EmptyState: FC<EmptyStateProps> = ({ message }) => (
  <IonGrid>
    <IonRow>
      <IonCol style={{ padding: '1em', textAlign: 'center', color: '#888' }}>
        {message}
      </IonCol>
    </IonRow>
  </IonGrid>
);

export default EmptyState;
